function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#288b94;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logoListaMatEdu");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M31.79,4.16H20a.91.91,0,0,0-.91.91v6.36H5.44a.91.91,0,0,0-.91.91V57.78a.9.9,0,0,0,.91.91H31.79a.9.9,0,0,0,.91-.91V5.07A.91.91,0,0,0,31.79,4.16Zm-.9,47.26h-10V49.6h10ZM6.35,17.79H19.07V45.06H6.35Zm24.54-3.63h-10V11.43h10ZM6.35,46.88H19.07V49.6H6.35Zm14.54.91V16h10V47.79ZM30.89,6V9.61h-10V6ZM19.07,13.25V16H6.35V13.25ZM6.35,51.42H19.07v5.45H6.35Zm14.54,5.45V53.24h10v3.63Z",
  transform: "translate(-4.53 -4.16)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M59,53.92,48.12,12.11a.94.94,0,0,0-.42-.56.93.93,0,0,0-.69-.09L33.38,15.1a.91.91,0,0,0-.65,1.1L43.64,58a.89.89,0,0,0,.42.56.93.93,0,0,0,.69.09L58.39,55A.9.9,0,0,0,59,53.92ZM36.17,22.17,48,19l.43,1.63L36.6,23.81Zm12.76.23L54.2,42.63,42.33,45.79,37.06,25.57Zm5.74,22L55.6,48,43.72,51.12l-.93-3.57ZM46.6,13.45l1,3.8L35.71,20.41l-1-3.79ZM45.17,56.67l-1-3.79,11.87-3.17,1,3.79Z",
  transform: "translate(-4.53 -4.16)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16.34,20.52H9.07a.91.91,0,0,0-.91.91V28.7a.91.91,0,0,0,.91.91h7.27a.91.91,0,0,0,.91-.91V21.43A.91.91,0,0,0,16.34,20.52Zm-.91,7.27H10V22.34h5.45Z",
  transform: "translate(-4.53 -4.16)"
});

var SvgLogoListaMatEdu = function SvgLogoListaMatEdu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 54.53 54.53",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoListaMatEdu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoListaMatEdu.491a2b9a.svg";
export { ForwardRef as ReactComponent };